<template>
    <section
        class="app-landing-section hidden-xs"
    >
        <div class="container flex flex-justify-space-between">
            <div class="flex flex-column flex-justify-center flex-align-start">
                <h1 class="app-landing-section__title mt-0 mb-1 text-4xl text-black w-700">
                    {{ $t('common.downloadApp') }}
                </h1>
                <h2 class="m-0 text-darker text-lg w-normal">
                    {{ $t('webSiteDescription') }}
                </h2>

                <div class="app-landing-section__app mt-4">
                    <div class="text-center">
                        <a :href="getAdjustLink()" class="download-btn btn px-3 btn-lg text-white">
                            <div class="flex flex-row flex-align-center ml-3">
                                <mobile-icon stroke="white" width="16" height="28" />
                                <div class="mr-3 flex flex-column flex-align-start">
                                    <span class="text-sm mb-1">
                                        {{ $t('downloadApplication') }}
                                    </span>
                                    <img :src="$image('app/alibaba-ir-app.svg')" alt="application screenshot">
                                </div>
                            </div>
                        </a>
                        <p class="mt-1 mb-0 text-dark text-sm">
                            {{ $t('downloadIosAndAndroid') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex">
                <div class="app-screenshot">
                    <img :src="$image('app/app-screenshot.png')" :srcset="`${$image('app/app-screenshot@2x.png')} 2x`" alt="application screenshot">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MobileIcon from '~icons/mobile-icon';

export default {
    components: {
        MobileIcon,
    },
    methods: {
        getAdjustLink (link = 'https%3A%2F%2Fwww.alibaba.ir%2Fapp') {
            return `https://app.adjust.com/euthkx3?engagement_type=fallback_click&redirect=${link}%3Fnotracker%3Dtrue%26utm_source%3Dapp-promotion-section%26utm_medium%3Dwebsite%26utm_campaign%3Donsite-promotion-q4`;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~vars';

    .download-btn {
        background-color: $alibaba-blue-button;
        box-shadow: 0 8px 16px 0 rgba($black, 0.1);

        &:hover {
            color: white;
        }
    }

    .app-landing-section {
        background-color: $gray-lightest;
        background-image: url('~assets/images/app/app-section-bg.png');
        background-position: right top;
        background-repeat: no-repeat, no-repeat;
    }

</style>

<i18n>
{
    "fa": {
        "webSiteDescription": "آسان‌ترین راه خرید بلیط، هتل و تور",
        "downloadApplication": "دانلود اپلیکیشن از",
        "downloadIosAndAndroid": "دانلود اپلیکیشن‌های اندروید و iOS"
    }
}
</i18n>
